export enum TransitionalCareVisitTypeEnum {
    Inpatient = 1,
    ED = 2,
}
